import { useEffect } from "react";

interface PageSEOData {
  title: string;
  description: string;
  canonicalPath: string;
  imageUrl?: string;
}

const SITE_DOMAIN = typeof import.meta !== "undefined" && (import.meta as Record<string, unknown>).env ? ((import.meta as Record<string, Record<string, string>>).env.VITE_SITE_URL ?? "https://sugargoospreadsheet.delivery") : "https://sugargoospreadsheet.delivery";

function setMetaTag(selector: string, attr: string, value: string): void {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    const nameOrProp = selector.includes('property="') ? "property" : "name";
    const match = selector.match(new RegExp(`${nameOrProp}="([^"]+)"`));
    if (match) {
      el.setAttribute(nameOrProp, match[1]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function usePageSEO(data: PageSEOData): void {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const fullUrl = `${SITE_DOMAIN}${data.canonicalPath}`;

    document.title = data.title;

    setMetaTag('meta[name="description"]', "content", data.description);
    setMetaTag('meta[property="og:title"]', "content", data.title);
    setMetaTag('meta[property="og:description"]', "content", data.description);
    setMetaTag('meta[property="og:url"]', "content", fullUrl);
    setMetaTag('meta[name="twitter:title"]', "content", data.title);
    setMetaTag('meta[name="twitter:description"]', "content", data.description);

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = fullUrl;

    if (data.imageUrl) {
      setMetaTag('meta[property="og:image"]', "content", data.imageUrl);
      setMetaTag('meta[name="twitter:image"]', "content", data.imageUrl);
    }
  }, [data.title, data.description, data.canonicalPath, data.imageUrl]);
}